export enum ClientDataTypes {
    PresenterJoined = 'presenterJoined'
}